export interface AgenceProfil {
  nomAgence: string;
  responsable: string;
  email: string;
  telephone: string;
  /** Aperçu du logo (data URL) — jamais persisté tel quel. */
  logo: string;
  /** Chemin Storage du logo persisté (`agences.logo_url`). */
  logoPath: string;
  /** Adresse postale, affichée dans l'en-tête et le pied de page des PDF. */
  adresse: string;
  /** Site web affiché dans les documents PDF. */
  siteWeb: string;
  /** Identifiant Financier Unique (facultatif). */
  ifu: string;
  /** Registre du Commerce et du Crédit Mobilier (facultatif). */
  rccm: string;
}

export interface AgencePreferences {
  notifLoyer: boolean;
  notifPaiement: boolean;
  notifImpaye: boolean;
  notifContrat: boolean;
  notifEmploye: boolean;
  notifEmail: boolean;
  langue: string;
  devise: string;
  formatDate: string;
}

export const LANGUE_OPTIONS = [
  { value: "fr", label: "Français" },
  { value: "en", label: "Anglais" },
];

export const DEVISE_OPTIONS = [{ value: "XOF", label: "FCFA (XOF)" }];

export const FORMAT_DATE_OPTIONS = [
  { value: "jj/mm/aaaa", label: "jj/mm/aaaa" },
  { value: "aaaa-mm-jj", label: "aaaa-mm-jj" },
  { value: "jj mois aaaa", label: "jj mois aaaa" },
];

/**
 * Modèle de données prévu pour Supabase.
 * Profil  : table `agences` (nom, responsable, email, telephone, logo, adresse).
 * Prefs   : colonnes jsonb sur la table de l'agence (notifications, langue, devise…).
 * Sécurité: gérée par Supabase Auth (auth.updateUser / auth.signOut).
 */